/**
 *
 * UnveifiedEmailModal
 *
 */

import React, { Component } from "react";
import { Wrapper, Text } from "./styledComponents";
import { connect } from "react-redux";
import Modal from "components/Modal";
import { selectVerificationResent } from "containers/SelfSignUp/selectors";
import { A } from "../../containers/SelfSignUp/styledComponents";
import { resendVerificationRequest } from "../../containers/SelfSignUp/actions";
import { createStructuredSelector } from "reselect";

class UnverifiedEmailModal extends Component {
  state = {
    successfullyResent: false,
  };

  componentDidUpdate(prevProps) {
    const { verificationResent } = this.props;
    if (prevProps.verificationResent === false && verificationResent) {
      this.setState({ successfullyResent: true });
    }
  }
  render() {
    const { close, resendVerificationEmail, email } = this.props;

    return (
      <Modal
        close={close}
        title={
          this.state.successfullyResent ? "Success!" : "Verify your email!"
        }
      >
        <Wrapper>
          {this.state.successfullyResent ? (
            <Text>
              An email with instructions for verifying your account have been
              sent to you.
            </Text>
          ) : (
            <Text>
              It looks like you have an account but the the email address you
              used has not been verified yet. You should have received an email
              with a "Verify Me" link. If you need it again, we can{" "}
              <A
                to="/sign-in"
                onClick={() => {
                  resendVerificationEmail({ email });
                }}
              >
                {" "}
                resend it
              </A>{" "}
              to you.
            </Text>
          )}
        </Wrapper>
      </Modal>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  email: (state) => state.form.signIn.values.email,
  verificationResent: selectVerificationResent(),
});

const mapDispatchToProps = (dispatch) => ({
  resendVerificationEmail: (email) =>
    dispatch(resendVerificationRequest(email)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnverifiedEmailModal);



// WEBPACK FOOTER //
// ./src/components/UnverifiedEmailModal/index.js